import * as React from 'react';

import * as styles from './Controls.css';

export const Controls = ({ children }: React.PropsWithChildren) => {
  return (
    <div className={styles['container']}>
      {React.Children.map(children, (item, index) => {
        return (
          <div key={index} className={styles['button']}>
            {item}
          </div>
        );
      })}
    </div>
  );
};
